/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { ru } from 'vuetify/locale'

// Composables
import { createVuetify } from 'vuetify'

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#748E2B',
          secondary: '#EAEEDF',
          accent: '#82B1FF',
          error: '#FF5252',
          info: '#D9D9D9',
          success: '#4CAF50',
          warning: '#FFC107',
          // brand:
          brandPrimary: '#748E2B',
          brandSecondary: '#EAEEDF',
          brandLight: '#F8FAF5',
          brandWhite: '#FFFFFF',
          brandGray: '#D9D9D9',
          brandDarkGray: '#747474',
          brandBlack: '#000000',
        },
      },
    },
  },
  locale: {
    locale: 'ru',
    messages: {
      ru: {
        ...ru,
      },
    },
  },

})
